/** Plan months Twelve will fund, counting from the first plan month (index 0). */
export function resolveFundingCommitmentMonths(state) {
  const planMonthCount = state?.marketing?.length ?? 0;
  if (planMonthCount <= 0) {
    return 0;
  }
  const raw = state?.commitmentMonths;
  if (raw == null || raw === '') {
    return planMonthCount;
  }
  return Math.max(1, Math.min(planMonthCount, Math.floor(Number(raw) || 1)));
}

export function isPlanMonthOutsideCommitment(state, planIndex) {
  if (state?.commitmentMonths == null || state?.commitmentMonths === '') {
    return false;
  }
  return planIndex >= resolveFundingCommitmentMonths(state);
}

export function applyCommitmentToPlanArrays(state) {
  const commitmentMonths = resolveFundingCommitmentMonths(state);
  return {
    ...state,
    fundingPct: (state.fundingPct ?? []).map((pct, index) =>
      index < commitmentMonths ? Number(pct) || 0 : 0
    ),
    revSharePct: (state.revSharePct ?? []).map((pct, index) =>
      index < commitmentMonths ? Number(pct) || 0 : 0
    ),
    planDrawAmount: (state.planDrawAmount ?? []).map((amount, index) =>
      index < commitmentMonths ? amount : null
    ),
  };
}
